import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { requireRole } from "@/features/auth/guards";

/**
 * My space portal layout. Employees, and the SMM, who posts on their own
 * LinkedIn like everyone else and keeps the same private space (SB-40).
 */
export const Route = createFileRoute("/_authenticated/me")({
  beforeLoad: () => requireRole("employee", "smm"),
  component: () => <AppShell portal="me" />,
});
